module.exports = __webpack_public_path__ + "static/img/tips_img2.f7240e04.png";